import { render, staticRenderFns } from "./for-law-enforcement.vue?vue&type=template&id=665af2b6&scoped=true"
import script from "./for-law-enforcement.vue?vue&type=script&lang=js"
export * from "./for-law-enforcement.vue?vue&type=script&lang=js"
import style0 from "./for-law-enforcement.vue?vue&type=style&index=0&id=665af2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665af2b6",
  null
  
)

export default component.exports